import {
    Button,
    Col,
    Input,
    Row,
    Space,
} from 'antd';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { SearchParamValue } from '../../interfaces/paginate.interface';

interface Props {
    loading: boolean;
    handleSearchParam: (key: string, value: SearchParamValue) => void;
    setOpenAddDriver: (open: boolean) => void;
    setOpenBulkImport: (open: boolean) => void;
    refreshData: () => void;
    extra?: ReactNode;
}

const { Search }: any = Input;

const Filters = ({
    loading,
    handleSearchParam,
    refreshData,
    setOpenAddDriver,
    setOpenBulkImport,
    extra,
}: Props) => {
    const { t } = useTranslation('drivers', { keyPrefix: 'DRIVERS' });

    return (
        <Row className="home__filters" gutter={[16, 16]} justify="space-between" align="middle">
            <Col className="home__filters--col-search">
                <Search
                    style={{ width: 300 }}
                    allowClear
                    placeholder={t('SEARCH')}
                    onSearch={(value: string) => handleSearchParam('search', value)}
                    enterButton
                    disabled={loading}
                />
            </Col>
            {extra && (
                <Col flex="auto" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    {extra}
                </Col>
            )}
            <Col>
                <Space>
                    {/* <Button onClick={() => setOpenBulkImport(true)}>
                        {t('BULK.IMPORT')}
                    </Button> */}
                    <Button
                        type="primary"
                        onClick={() => setOpenAddDriver(true)}
                    >
                        {t('ADD')}
                    </Button>
                </Space>
            </Col>
        </Row>
    );
};

export { Filters };
